// @flow
import React from 'react';
import {StyleSheet, View} from 'react-native';
import {Text} from 'trpc-react-native-ui';
import I18n from '../../../lib/i18n';
import FontService from '../../../lib/font';
import theme from '../../../theme-config';

type Props = {
  text?: string,
};

const NewBadge = ({text}: Props) => (
  <View style={styles.badge}>
    <Text style={styles.text}>{text || I18n.t('stepper.newBadge')}</Text>
  </View>
);

const styles = StyleSheet.create({
  badge: {
    backgroundColor: '#FDD90D',
    paddingHorizontal: 8,
    paddingVertical: 3,
    marginLeft: 8,
  },
  text: {
    color: theme.secondaryColor,
    fontSize: 12,
    fontWeight: 'bold',
    ...FontService.getStyle(theme.fontFamily, 'bold', false),
  },
});

export default NewBadge;
